import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Popup from "../ui/Popup";
import AccessCodeForm from "./AccessCodeForm";
import { getStoredAccessCode } from "../../lib/registration";

const RESERVATIONS_PATH = "/reservations";

/** Reserve CTA: a plain link once registration is open (or a code was accepted), otherwise it asks for the code first. */
const ReserveButton = ({ isOpen, className, children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  if (isOpen || getStoredAccessCode()) {
    return (
      <Link className={className} to={RESERVATIONS_PATH}>
        {children}
      </Link>
    );
  }

  return (
    <>
      <button type="button" className={className} onClick={() => setIsPopupOpen(true)}>
        {children}
      </button>
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} title="Registrace ještě není otevřená">
        <p className="mb-4">
          Máš přístupový kód? Zadej ho a místo si můžeš zarezervovat už teď. Jeden kód platí pro jeden tým.
        </p>
        <AccessCodeForm idPrefix="popup-access" onUnlocked={() => navigate(RESERVATIONS_PATH)} />
      </Popup>
    </>
  );
};

export default ReserveButton;
